module.exports = __webpack_public_path__ + "img/9788963711546.97115df5.jpg";